import { showAlert } from "../components/common/ErrorAlert/ErrorAlert";
import api from "./api";
import useUserStore from "../store/useUserStore";

export async function getInvoiceDetails(uuid) {
  try {
    const response = await api.get(`invoices/${uuid}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getInvoicesList(params = {}) {
  try {
    const response = await api.get("invoices/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const fetchActiveInvoices = async () => {
  try {
    const response = await api.get(`invoices/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map((invoice) => ({
        label: invoice.invoice_id,
        value: invoice.id,
      }));
    }
    return [];
  } catch (error) {
    return [];
  }
};

export async function InvoiceAdd(formData) {
  try {
    const response = await api.post("invoices/create/", formData);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function InvoiceEdit(Id, formData) {
  try {
    const response = await api.put(`invoices/?id=${Id}`, formData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function InvoicesArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("invoices/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`invoices/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

// export async function InvoiceAddressList(params = {}) {
//   try {
//     const response = await api.get(`invoices/address/`, { params });
//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// }

// export async function InvoiceProductList(params = {}) {
//   try {
//     const response = await api.get("invoices/product/", { params });
//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// }

// export async function InvoiceProductAdd(formData) {
//   try {
//     const response = await api.post("invoices/product/", formData);
//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// }

// export async function CheckInvoiceExist(sales_id) {
//   try {
//     const response = await api.get(`invoices/check-invoice/`, {
//       params: { sales_id: sales_id },
//     });
//     return response.data;
//   } catch (error) {
//     console.log(error);
//   }
// }

export async function CheckInvoiced(sales_id) {
  try {
    const response = await api.get(`invoices/check-invoice-status/`, {
      params: { sales_id: sales_id },
    });
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getCustomerPaymentTermDays(customerId) {
  try {
    const { data } = await api.get(`customer/${customerId}/payment-term-days/`);
    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
}

export async function CheckRemainingProducts(sales_id) {
  console.log("sales", sales_id);
  try {
    const response = await api.get(`invoices/check-products/`, {
      params: { sales_id: sales_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function CheckInvoicePaymentStatus(invoice_id) {
  try {
    const response = await api.get(`invoices/payment-status/`, {
      params: { invoice_id: invoice_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function CurrencyCreate(data) {
  try {
    const response = await api.post("organization/currencies/", data);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getCurrencies(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`organization/currencies/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("organization/currencies/", { params });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function CurrencyEdit(Id, formData) {
  try {
    const response = await api.put(
      `organization/currencies/?id=${Id}`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CurrencyArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("organization/currencies/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`organization/currencies/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export const toggleCurrencyStatus = async (uuid) => {
  try {
    const response = await api.post(`organization/currencies/toggle/${uuid}/`);
    return response.data;
  } catch (error) {
    showAlert(error?.response?.data?.message || "Failed to update currency status.");
    throw error;
  }
};

export const GetActiveCurrency = async () => {
  try {
    const response = await api.get(`organization/currencies/active/`);
    return response.data;
  } catch (error) {
    return [];
  }
};

export const fetchActiveCurrencies = async () => {
  try {
    const response = await api.get(`organization/currencies/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map((invoice) => ({
        label: `${invoice.name} (${invoice.currency_code})`,
        value: invoice.id,
      }));
    }
    return [];
  } catch (error) {
    return [];
  }
};

///VENDOR BILLS

export async function CheckVendorBills(purchase_id) {
  try {
    const response = await api.get(`vendor-bills/check-status/`, {
      params: { purchase_id: purchase_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function VendorbillList(params = {}) {
  try {
    const response = await api.get("vendor-bills/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getVendorBill(uuid) {
  try {
    const response = await api.get(`vendor-bills/${uuid}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function VendorBillsAdd(formData) {
  try {
    const response = await api.post("vendor-bills/create/", formData);
    return response;
  } catch (error) {
    showAlert(error?.response?.data?.message);
  }
}

export async function VendorBillArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("vendor-bills/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`vendor-bills/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPendingBillItems(purchase_id) {
  try {
    const response = await api.get(`vendor-bills/check-products/`, {
      params: { purchase_id: purchase_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function GetBillableOrders(vendor_id = null) {
  try {
    const params = vendor_id ? { vendor_id } : {};
    const response = await api.get(`purchases/billable-orders/`, { params });
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function GetInvoiceableOrders(customer_id = null) {
  try {
    const params = customer_id ? { customer_id } : {};
    const response = await api.get(`invoices/invoiceable-orders/`, { params });
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function CheckVendorPaymentStatus(vendor_bill_id) {
  try {
    const response = await api.get(`vendor-bills/payment-status/`, {
      params: { vendor_bill_id: vendor_bill_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export const fetchActiveVendorbills = async () => {
  try {
    const response = await api.get(`vendor-bills/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map((bill) => ({
        label: bill.uid,
        value: bill.id,
      }));
    }
    return [];
  } catch (error) {
    return [];
  }
};

// chart of accounts
// services/accounting.js
export async function GetChartOfAccountsByJournalType(journalType) {
  try {
    const response = await api.get("accounting/chartofaccounts-by-journal/", {
      params: { journal_type: journalType },
    });
    return response.data;
  } catch (error) {
    return { error };
  }
}

export async function GetChartOfAccounts(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(
        `accounting/organization-chartofaccount/?id=${id}`,
      );
      return response.data;
    } else {
      const response = await api.get(
        "accounting/organization-chartofaccount/",
        { params },
      );
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function GetActiveChartOfAccounts(params = {}) {
  try {
    const response = await api.get(
      "accounting/organization-chartofaccount/active/",
      { params }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
export async function GetCurrentAssetsChartOfAccounts() {
  try {
    const response = await api.get(
      "accounting/organization-chartofaccount/current-assets/",
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}


export async function CreateChartOfAccount(data) {
  try {
    const response = await api.post(
      "accounting/organization-chartofaccount/",
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const GetChartOfAccountById = async (id) => {
  try {
    const response = await api.get(
      `accounting/organization-chartofaccount/?id=${id}`,
    );
    return response.data;
  } catch (error) {
    return {
      response_code: 0,
      message: error.message || "Failed to fetch account details",
    };
  }
};

export const UpdateChartOfAccount = async (id, payload) => {
  try {
    const response = await api.put(
      `accounting/organization-chartofaccount/?id=${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function ChartOfAccountArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post(
        "accounting/organization-chartofaccount/archive/",
        {
          id_list: id_list,
        },
      );
    } else {
      response = await api.get(
        `accounting/organization-chartofaccount/archive/?id=${id}`,
      );
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getJournalType(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`accounting/journal-type/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("accounting/journal-type/", { params });
      return response.data;
    }
  } catch (error) {
    return { error };
  }
}

export async function getAccountTypes(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`accounting/account-type/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("accounting/account-type/", { params });
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function GetJournals(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`accounting/journal/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("accounting/journal/", { params });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}
export async function CreateJournals(data) {
  try {
    const response = await api.post("accounting/journal/", data);
    return response.data;
  } catch (error) {
    throw error;
  }
}
export const UpdateJournals = async (id, payload) => {
  try {
    const response = await api.put(`accounting/journal/?id=${id}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const GetJournalById = async (id) => {
  try {
    const res = await api.get(`accounting/journal/?id=${id}`);
    return res.data;
  } catch (err) {
    return null;
  }
};

export async function JournalsArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("accounting/journal/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`accounting/journal/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

// export async function AddChartOfAccount(formData) {
//   try {
//     const response = await api.post("accounting/organization-chartofaccount/", formData);
//     return response;
//   } catch (error) {
//     return { error };
//   }
// }

export async function GetJournalEntries(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`accounting/journal-entry/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("accounting/journal-entry/", { params });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}
export async function JournalEntriesArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("accounting/journalentry/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`accounting/journalentry/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export const UpdateJournalEntry = async (id, payload) => {
  try {
    const response = await api.put(
      `accounting/journal-entry/?id=${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    return { response_code: 0, message: error.message || "Update failed" };
  }
};

export const GetJournalEntryById = async (id) => {
  try {
    const res = await api.get(`accounting/journal-entry/?id=${id}`);
    return res.data;
  } catch (err) {
    return null;
  }
};

export async function GetTaxes(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`organization/organization-tax/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("organization/organization-tax/", {
        params,
      });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function CreateTaxes(data) {
  try {
    const response = await api.post("organization/organization-tax/", data);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const UpdateTax = async (uuid, payload) => {
  try {
    const response = await api.put(
      `organization/organization-tax/${uuid}/`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const GetTaxById = async (id) => {
  try {
    const response = await api.get(`organization/organization-tax/?id=${id}`);
    return response.data;
  } catch (error) {
    return {
      response_code: 0,
      message: error.message || "Failed to fetch account details",
    };
  }
};

// export const fetchActiveTax = async (currencySymbol) => {
//   try {
//     const response = await api.get(`organization/organization-tax/active/`);
//     const result = response.data;
//     if (result.response_code === 1 && Array.isArray(result.data)) {
//       return result.data.map(tax => ({
//         label: tax.tax_type === "Percentage"
//           ? `${tax.name} (${tax.tax_rate}%)`
//           : `${tax.name} (${currencySymbol}${tax.tax_rate})`,
//         value: tax.id,
//         type: tax.tax_type,
//         rate: tax.tax_rate
//       }));
//     }

//     return [];
//   } catch (error) {
//     return [];
//   }
// };

export async function TaxArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("organization/organization-tax/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(
        `organization/organization-tax/archive/?id=${id}`,
      );
    }
    return response;
  } catch (error) {
    throw error;
  }
}

// export async function GetLedgers(type = "all", from_date = "", to_date = "") {
//   try {
//     const response = await api.get(`accounting/transactions/ledgers/`, {
//       params: {
//         type,
//         from_date,
//         to_date,
//       },
//     });
//     return response;
//   } catch (error) {
//     console.error("Error fetching ledgers: ", error);
//   }
// }

export async function GetLedgers(account_id, from_date = "", to_date = "") {
  try {
    const response = await api.get("/accounting/transactions/ledgers/", {
      params: {
        account_id,
        from_date,
        to_date,
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function GetAgedReceivables(
  based_on = "due_date",
  from_date = "",
  to_date = "",
) {
  try {
    const response = await api.get("/invoices/aged-receivables/", {
      params: {
        based_on,
        from_date,
        to_date,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetAgedPayables(
  based_on = "due_date",
  from_date = "",
  to_date = "",
) {
  try {
    const response = await api.get("/vendor-bills/aged-payables/", {
      params: {
        based_on,
        from_date,
        to_date,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching aged payables:", error);
    throw error;
  }
}

export async function GetCustomerAgedReceivables(customerId, based_on) {
  try {
    const response = await api.get("/invoices/aged-receivables/", {
      params: {
        customer_id: customerId,
        based_on,
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function GetVendorAgedPayables(
  vendorName,
  based_on,
  from_date,
  to_date,
) {
  try {
    const response = await api.get("/vendor-bills/aged-payables/", {
      params: {
        vendor: vendorName,
        based_on,
        from_date,
        to_date,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function GetTrialBalance(
  period = "This Month",
  start_date = "",
  end_date = "",
) {
  try {
    const response = await api.get("/accounting/trial-balance/", {
      params: {
        period,
        start_date,
        end_date,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// Add this to your existing API services file (e.g., services/api.js)

export async function GetProfitAndLoss(
  period = "This Month",
  start_date = "",
  end_date = "",
) {
  try {
    const response = await api.get("/accounting/profit-loss/", {
      params: {
        period,
        start_date,
        end_date,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// services/reports.js
export async function GetBalanceSheet(
  period = "This Month",
  dateInput = "", // This can be either as_of_date or "YYYY-MM-DD → YYYY-MM-DD"
  showZeroValues = false,
) {
  try {
    let params = { period, show_zero_values: showZeroValues };

    // Check if it's a custom date range string
    if (dateInput && dateInput.includes("→")) {
      const dates = dateInput.split("→").map((d) => d.trim());
      if (dates.length === 2) {
        params.as_of_date = dates[1]; // Use end date
        params.period = "Custom"; // Override period to "Custom"
      }
    } else if (dateInput) {
      // Regular as_of_date
      params.as_of_date = dateInput;
    }

    const response = await api.get("/accounting/balance-sheet/", {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function ConfirmInvoice(uuid) {
  try {
    const response = await api.post(`invoices/${uuid}/confirm/`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CancelInvoice(uuid) {
  try {
    const response = await api.post(`invoices/${uuid}/cancel/`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function ConfirmVendorBill(vendorBillIdentifier) {
  try {
    const response = await api.post(
      `vendor-bills/confirm/${vendorBillIdentifier}/`,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function CancelVendorBill(uuid) {
  try {
    const response = await api.post(`vendor-bills/${uuid}/cancel/`);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function CreateJournalEntryPost(data) {
  try {
    const response = await api.post(
      "accounting/journal-entry/create/post/",
      data,
    );
    return response.data;
  } catch (error) {
    return {
      response_code: 0,
      message: error.message || "Server error",
    };
  }
}
export async function ConfirmPostJournalEntry(uuid) {
  try {
    const response = await api.post(
      `accounting/journal-entry/${uuid}/confirm-post/`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const GetGeneralLedger = (params) =>
  api.get("/accounting/general-ledger/", { params });

export const GetIncomeAccounts = async (params = {}) => {
  try {
    const response = await api.get(
      `accounting/organization-income-chartofaccount/`,
      { params: { limit: 1000, sort: "oldest", ...params } },
    );
    return response.data; // 👈 correct
  } catch (error) {
    return null;
  }
};

export const GetExpenseAccounts = async (params = {}) => {
  try {
    const response = await api.get(
      `accounting/organization-expense-chartofaccount/`,
      { params: { limit: 1000, sort: "oldest", ...params } },
    );
    return response.data;
  } catch (error) {
    return null;
  }
};

/**
 * High-performance paginated search for Chart of Accounts dropdown lookups.
 * Calls `accounting/chartofaccounts/lookup/` with pagination and debounced search.
 * Supports filtering by `type` ('income', 'expense', 'current_assets', etc.) or single `id`.
 */
export async function searchAccountLookup({
  search = "",
  page = 1,
  page_size = 20,
  type = "",
  account_type = "",
  id = null,
} = {}) {
  try {
    const params = {
      search,
      page,
      page_size,
    };
    const effectiveType = type || account_type;
    if (effectiveType) params.type = effectiveType;
    if (id) params.id = id;

    const response = await api.get("accounting/chartofaccounts/lookup/", { params });
    const data = response?.data;

    if (data && (Array.isArray(data.results) || Array.isArray(data.data))) {
      const rawList = data.results || data.data || [];
      const mapped = rawList.map((item) => ({
        id: item.id,
        value: item.id,
        label: item.label || (item.code ? `${item.code} - ${item.account_name}` : item.account_name),
        name: item.account_name,
        code: item.code,
        account_name: item.account_name,
        ...item,
      }));
      return {
        success: true,
        results: mapped,
        data: mapped,
        count: data.count ?? rawList.length,
        hasNext: Boolean(data.next),
        has_more: Boolean(data.next),
      };
    }
    return { success: false, results: [], data: [], count: 0, hasNext: false, has_more: false };
  } catch (error) {
    console.error("searchAccountLookup error:", error);
    return { success: false, results: [], data: [], count: 0, hasNext: false, has_more: false };
  }
}

export async function getInvoiceHSNTax(uuid) {
  try {
    const response = await api.get(`invoices/${uuid}/hsn-tax/`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function submitJournalOnboarding(id, serial_number) {
  try {
    const response = await api.post(`accounting/journal/submit-onboarding/?id=${id}`, { serial_number });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function completeJournalOnboarding(id, otp) {
  try {
    const response = await api.post(`accounting/journal/complete-onboarding/?id=${id}`, { otp });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function GetDefaultAccountingConfigurationDetail(id = null) {
  try {
    const url = id
      ? `accounting/default-accounting-configuration/?id=${id}`
      : "accounting/default-accounting-configuration/";
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function SaveDefaultAccountingConfiguration(data) {
  try {
    let response;
    if (data?.id) {
      response = await api.put(
        `accounting/default-accounting-configuration/?id=${data.id}`,
        data
      );
    } else {
      // Try PUT first as default accounting config can update/create active instance, fallback to POST if needed
      try {
        response = await api.put(
          "accounting/default-accounting-configuration/",
          data
        );
      } catch (err) {
        if (err.response && err.response.status === 404) {
          response = await api.post(
            "accounting/default-accounting-configuration/",
            data
          );
        } else {
          throw err;
        }
      }
    }
    return response.data;
  } catch (error) {
    throw error;
  }
}

export function normalizeJournalType(journalOrType) {
  if (!journalOrType) return "";
  const rawType =
    typeof journalOrType === "string"
      ? journalOrType
      : journalOrType.journal_type_name ||
        (typeof journalOrType.journal_type === "object"
          ? journalOrType.journal_type?.name
          : journalOrType.journal_type) ||
        "";
  const t = String(rawType).trim().toLowerCase();
  if (t === "expense" || t === "expenses" || t === "maintenance") return "miscellaneous";
  return t;
}

export function isJournalUnassigned(journal) {
  if (!journal) return false;
  const users =
    Array.isArray(journal.available_users) && journal.available_users.length > 0
      ? journal.available_users
      : Array.isArray(journal.available_users_data) && journal.available_users_data.length > 0
      ? journal.available_users_data
      : null;
  return !users || users.length === 0;
}

export function isJournalAssignedToUser(journal, currentUserId) {
  if (!journal || !currentUserId) return false;

  const users =
    Array.isArray(journal.available_users) && journal.available_users.length > 0
      ? journal.available_users
      : Array.isArray(journal.available_users_data) && journal.available_users_data.length > 0
      ? journal.available_users_data
      : null;

  if (!users || users.length === 0) {
    return false;
  }

  return users.some((u) => {
    const uId = typeof u === "object" && u !== null ? u.id : u;
    return String(uId) === String(currentUserId);
  });
}

export function isJournalAvailableForUser(journal, currentUserId, allJournals = null) {
  if (!journal) return false;
  const userId =
    currentUserId ??
    useUserStore.getState().user?.id ??
    (() => {
      try {
        return JSON.parse(localStorage.getItem("user") || "{}")?.id || null;
      } catch {
        return null;
      }
    })();

  const isAssigned = isJournalAssignedToUser(journal, userId);
  if (isAssigned) return true;

  const isUnassigned = isJournalUnassigned(journal);
  if (!isUnassigned) {
    return false;
  }

  if (Array.isArray(allJournals) && allJournals.length > 0) {
    const targetType = normalizeJournalType(journal);
    const hasAssignedInType = allJournals.some(
      (j) => normalizeJournalType(j) === targetType && isJournalAssignedToUser(j, userId)
    );
    return !hasAssignedInType;
  }

  return true;
}

export function filterJournalsByUser(journals, currentUserId = null) {
  if (!Array.isArray(journals)) return [];
  const userId =
    currentUserId ??
    useUserStore.getState().user?.id ??
    (() => {
      try {
        return JSON.parse(localStorage.getItem("user") || "{}")?.id || null;
      } catch {
        return null;
      }
    })();

  // Group journals by normalized journal type
  const typeGroups = new Map();
  journals.forEach((j) => {
    const typeKey = normalizeJournalType(j);
    if (!typeGroups.has(typeKey)) {
      typeGroups.set(typeKey, []);
    }
    typeGroups.get(typeKey).push(j);
  });

  const filtered = [];

  for (const [, groupJournals] of typeGroups) {
    const userAssigned = groupJournals.filter((j) =>
      isJournalAssignedToUser(j, userId)
    );

    if (userAssigned.length > 0) {
      // If user has assigned journal(s) of this type, ONLY display the assigned journals
      filtered.push(...userAssigned);
    } else {
      // If user does not have assigned journal of this type, display all journals not assigned to any users
      const unassigned = groupJournals.filter((j) => isJournalUnassigned(j));
      filtered.push(...unassigned);
    }
  }

  const filteredSet = new Set(filtered);
  return journals.filter((j) => filteredSet.has(j));
}

export function getDefaultJournal(journals, currentUserId = null, preferredType = null) {
  if (!Array.isArray(journals) || journals.length === 0) {
    return null;
  }

  const userId =
    currentUserId ??
    useUserStore.getState().user?.id ??
    (() => {
      try {
        return JSON.parse(localStorage.getItem("user") || "{}")?.id || null;
      } catch {
        return null;
      }
    })();

  const isMatchingType = (j, type) => {
    if (!type) return false;
    const jNorm = normalizeJournalType(j);
    if (Array.isArray(type)) {
      return type.some((t) => normalizeJournalType(t) === jNorm);
    }
    return normalizeJournalType(type) === jNorm;
  };

  // Priority 1: User assigned journal of corresponding type.
  // If multiple journals assigned in same type, default value is the last journal.
  if (preferredType) {
    const userAssignedOfType = journals.filter(
      (j) => isMatchingType(j, preferredType) && isJournalAssignedToUser(j, userId)
    );
    if (userAssignedOfType.length > 0) {
      const lastAssigned = userAssignedOfType[userAssignedOfType.length - 1];
      return lastAssigned.id ?? lastAssigned.value;
    }
  }

  // If user has any assigned journal in the available list (e.g. multi-type dropdown):
  const userAssignedAny = journals.filter((j) => isJournalAssignedToUser(j, userId));
  if (userAssignedAny.length > 0) {
    const lastAssigned = userAssignedAny[userAssignedAny.length - 1];
    return lastAssigned.id ?? lastAssigned.value;
  }

  // Priority 2: If no journal assigned (to user), default value is last journal of corresponding type
  if (preferredType) {
    const ofType = journals.filter((j) => isMatchingType(j, preferredType));
    if (ofType.length > 0) {
      const lastOfType = ofType[ofType.length - 1];
      return lastOfType.id ?? lastOfType.value;
    }
  }

  // Fallback to the last journal in the available list
  const lastJournal = journals[journals.length - 1];
  return lastJournal.id ?? lastJournal.value;
}

export async function getDefaultJournalConfig(
  configKey = "sales_journal",
  filterJournalTypes = null
) {
  try {
    const journalsResponse = await GetJournals();

    let journalOptions = [];
    let defaultJournalId = null;

    const rawData =
      journalsResponse?.data?.data ||
      journalsResponse?.data ||
      (Array.isArray(journalsResponse) ? journalsResponse : []);
    const journalsList = Array.isArray(rawData) ? rawData : [];

    if (journalsList.length > 0) {
      let allowedTypes = null;
      let preferredType = null;

      if (configKey) {
        const derivedType = configKey.replace("_journal", "");
        preferredType =
          derivedType.charAt(0).toUpperCase() + derivedType.slice(1);
      }

      if (filterJournalTypes) {
        allowedTypes = Array.isArray(filterJournalTypes)
          ? filterJournalTypes
          : [filterJournalTypes];
        if (!preferredType && allowedTypes.length > 0) {
          preferredType = allowedTypes[0];
        }
      } else if (preferredType) {
        allowedTypes = [preferredType];
      }

      const currentUser = useUserStore.getState().user;
      const currentUserId =
        currentUser?.id ??
        (() => {
          try {
            return JSON.parse(localStorage.getItem("user") || "{}")?.id || null;
          } catch {
            return null;
          }
        })();

      // Filter by allowed types if specified
      const journalsOfType = journalsList.filter((journal) => {
        if (!allowedTypes) return true;
        const jNorm = normalizeJournalType(journal);
        return allowedTypes.some((t) => normalizeJournalType(t) === jNorm);
      });

      const filteredJournals = filterJournalsByUser(
        journalsOfType,
        currentUserId
      );

      journalOptions = filteredJournals.map((journal) => ({
        id: journal.id,
        name: journal.name,
        label: journal.name,
        value: journal.id,
        journal_type: journal.journal_type_name,
        journal_type_name: journal.journal_type_name,
        default_account: journal.default_account_name,
        available_users: journal.available_users,
        available_users_data: journal.available_users_data,
      }));

      defaultJournalId = getDefaultJournal(
        filteredJournals,
        currentUserId,
        preferredType
      );
    }

    return {
      journals: journalOptions,
      defaultJournalId,
    };
  } catch (error) {
    console.error(`Failed to fetch journals for ${configKey}:`, error);
    return { journals: [], defaultJournalId: null };
  }
}

export async function getDefaultJournalForType(
  journalType = "Sales",
  filterTypes = null
) {
  const configKey = `${journalType.toLowerCase()}_journal`;
  return getDefaultJournalConfig(configKey, filterTypes || [journalType]);
}

export async function GetFinancialYearLockData() {
  try {
    const response = await api.get("organization/financial-year-lock/");
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function ToggleFinancialYearLock(id, action) {
  try {
    const response = await api.post(`organization/financial-year-lock/${id}/toggle-lock/`, { action });
    return response.data;
  } catch (error) {
    throw error;
  }
}



